

export default function BSCICCertificate() {
  return (
    <div className="min-h-screen bg-background-surface flex justify-center px-md py-xl">
      <div
        className="
          w-full max-w-md
          bg-background-main
          rounded-lg
          shadow-panel
          px-lg py-xl
        "
      >
        {/* Logo */}
        <div className=" mb-lg">
          <img
            src="https://training.bscic.com/static/img/logo.jpg"
            alt="BSCIC Logo"
            className="h-20 object-contain"
          />
        </div>

        {/* Company Name */}
        <h1 className="text-h2 font-bold text-text-primary  mb-md">
          BSCIC Certifications Pvt. Ltd.
        </h1>

        {/* Declaration Title */}
        <h2 className="text-primary text-h3 text-[#2C6AB9] font-semibold text-center mb-md">
          DECLARATION
        </h2>

        {/* Declaration Text */}
        <p className="   font-normal text-center leading-body mb-lg">
          “BSCIC appreciates and values your search for the registration.
          The submitted information revealed the following details:”
        </p>

        {/* Details Card */}
        <div
          className="
            border-l-4 border-[#2A689E]
            bg-[#F1F1F1]
            p-4
            space-y-sm
            my-8
          "
        >
          <Detail label="Candidate Name" value="Faishal Shamim" />
          <Detail label="Management System Standard" value="ISO 9001:2015" />
          <Detail label="Certificate" value="BTO/C2512/08:1225" />
          <Detail label="ID" value="678046" />
          <Detail
            label="Awarded"
            value="Certificate of Successful Completion"
          />
          <Detail label="Course From Date" value="2025-11-11" />
          <Detail label="Course To Date" value="2025-11-19" />
          <Detail label="Original Issued Date" value="2025-12-30" />
          <Detail label="Country" value="INDIA" />
        </div>

        {/* Regards */}
        <p className="text-body text-text-primary mb-3">
          Best Regards
        </p>

        <p className="text-body font-semibold text-text-primary mb-lg">
          on behalf of BSCIC Certifications Pvt. Ltd.
        </p>

        {/* Signature */}
        <div className="mt-6 mb-4">
          <p className="text-body text-text-primary">Sanjay Seth</p>
          <p className="text-small text-text-secondary">
            Managing Director
          </p>
        </div>

        {/* Print Button (UI only) */}
        <div className="flex justify-center">
          <button
            className="
              flex items-center gap-sm
              text-xl
              px-xl py-sm
              bg-[#0f5593e0] px-8 py-2
              text-white
              rounded-md
              shadow-secondary
              hover:bg-primary-hover
              transition
              hover:bg-[#B1181C]
              cursor-pointer
            "
          >
            
            Print
          </button>
        </div>
      </div>
    </div>
  );
}

/* Reusable row */
function Detail({ label, value }) {
  return (
    <div className="my-2">
      <p className="text-small font-medium text-text-primary">
        {label}:
      </p>
      <p className="text-body text-text-secondary">
        {value}
      </p>
    </div>
  );
}
